import * as React from 'react';
import cn from '~modules/cn';
import Styles from './popup-view.module.scss';

type Props = React.ComponentPropsWithRef<'div'>;

const PopupView = React.forwardRef<HTMLDivElement, Props>((props, ref) => <div {...props} ref={ref} className={cn(Styles.view, props.className)} />);

PopupView.displayName = 'PopupView';

export default PopupView;
